import { useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import { getDoc, doc, collection, DocumentSnapshot } from "firebase/firestore"
import { db } from "../firebase";

export const BreadcrumbsCustomer = () => {
  const { customerId } = useParams()
  const [customerName, setCustomerName] = useState<string>('')
  const customersRef = collection(db, "customers")

  useEffect(() => {
    getDoc(doc(customersRef, customerId)).then((doc: DocumentSnapshot) => {
      doc.exists() && setCustomerName(doc.data().companyName)
    })
  })

  return <>{customerName ? customerName : "-"}</>;
};
